<script type="text/babel">
export default {
    filters: {
        capitalize: function (value) {
            if(!value) {
                return value;
            }
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        toUpperCase: function (value) {
            if(!value) {
                return '';
            }
            value = value.toString();
            return value.toUpperCase();
        }
    }
};
</script>

